import { ImageCircle } from '$components'
import { Text } from '$components'

export type Person = {
  first_name: string,
  last_name: string,
  image: string,
}

export type PersonCellProps = {
  data: Person,
}

export function PersonCell({ data }: PersonCellProps) {

  return (
    <div className="flex items-center gap-stack-tight">
      <ImageCircle
        image={data.image}
        size="lg"
      />
      <Text
        type="s"
        className="text-nowrap"
      >
        {data.first_name} {data.last_name}
      </Text>
    </div>
  )
}
